
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DanisWeber",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DanisWeber.vue